const setSearchValue = searchValue => ({
  type: 'SCHOOL_STUDENTS_FILTER:SET_SEARCH_VALUE',
  searchValue
})

export { setSearchValue }
